import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import Swal from "sweetalert2";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";

@ModuleName("B2BHistory")
export class B2BHistory implements AxInit {
    constructor(private _I18nHelper = new I18nHelper(), private _axLoading = new AxLoading()) { }
    private initData: B2BHistoryInitData;

    AxInit(init: B2BHistoryInitData): void {
        this.initData = init;

        $('#b2bSalesHistoryListContainer').on('click', '.b2b-download__details-btn', x => {
            let $x = $(x.target);

            let posNr = parseInt($x.attr('data-pos'));
            let transNr = parseInt($x.attr('data-trans'));

            $(`.b2b__history-detail[data-pos=${posNr}][data-trans=${transNr}]`).html('');

            if (!$x.hasClass('active')) {
                this._axLoading.ShowLoadingIndicator($('#b2bSalesHistoryListContainer')[0]);

                AxessViewer.loadPartialView('/B2B/_Details',
                    {
                        transNr: transNr,
                        posNr: posNr
                    },
                    resp => {
                        $x.addClass('active');
                        $(`.b2b__history-detail[data-pos=${posNr}][data-trans=${transNr}]`).html(resp.returnView);
                        $(`.b2b__history-detail[data-pos=${posNr}][data-trans=${transNr}] .history__ax-cancel-btn`)
                            .click(e => {
                                this.confirmCancel($(e.delegateTarget));
                            });
                        this._axLoading.HideLoadingIndicator($('#b2bSalesHistoryListContainer')[0]);
                    },
                    {});
            } else {
                $x.removeClass('active');
            }
        });
    }

    confirmCancel($elem: JQuery<HTMLElement>) {
        let transNr = parseInt($elem.attr('data-trans'));
        let serialNr = parseInt($elem.attr('data-serial'));
        let poolNr = parseInt($elem.attr('data-pool'));
        let posNr = parseInt($elem.attr('data-pos'));

        let data = {
            transNr: transNr,
            serialNr: serialNr,
            poolNr: poolNr,
            posNr: posNr
        };

        AxessViewer.loadPartialView('/B2B/GetCancelSweetAlertHtml', data, (result) => {
            Swal.fire({
                title: '',
                footer: this.initData.text,
                html: result,
                showCancelButton: true,
                confirmButtonText: this._I18nHelper.GetTranslation(Translations.Confirmation),
                cancelButtonText: this._I18nHelper.GetTranslation(Translations.Cancel),
                heightAuto: true,
                icon: 'warning'
            }).then(resp => {
                if (resp.value) {
                    this.cancelTicket(transNr, posNr, serialNr);
                } else if (result.isDenied) {

                }
            });
        }, { dataType: 'html' });
    }

    cancelTicket(transNr, posNr, serialNr) {
        const data = {
            transNr: transNr,
            serialNr: serialNr,
            posNr: posNr
        };

        AxessViewer.loadPartialView('/B2B/CancelTicket', data, (resp) => {
            if (resp["error"] == false) {
                Swal.fire({
                    title: this._I18nHelper.GetTranslation(Translations.Success) + '!',
                    text: resp['message'],
                    confirmButtonText: 'Ok',
                    showConfirmButton: true,
                    icon: 'success'
                }).then((result) => {
                    location.reload();
                });
            } else {
                Swal.fire({
                    title: this._I18nHelper.GetTranslation(Translations.Error) + '!',
                    text: resp['message'],
                    confirmButtonText: 'OK',
                    icon: 'error'
                }).then((resp) => {
                    location.reload();
                });
            }
        }, {
            silent: true
        });
    }
}

interface B2BHistoryInitData {
    text: string;
}